import { Component } from 'react';
import Raven from 'raven-js';
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }
  componentDidCatch(error, info = {}) {
    const {
      name
    } = this.props;
    Raven.captureException(error, {
      extra: info,
      tags: {
        errorBoundaryName: name
      }
    });
    this.setState({
      hasError: true
    });
  }
  render() {
    const {
      ErrorContent,
      children
    } = this.props;
    if (this.state.hasError) {
      return ErrorContent;
    }
    return children;
  }
}
export default ErrorBoundary;